import { useLocation, withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { withLocalize } from 'react-localize-redux'
import { Box, Container, LinearProgress } from '@material-ui/core'
import PropTypes from 'prop-types'
import { identify } from 'utils/segmentTracking'
import { getSignupURL, setLocale } from 'utils/localstorage'
import ErrorMessage from 'components/ErrorMessage'
import * as Sentry from '@sentry/react'
import { auth as authModule, clubs as clubsModule } from 'redux/modules'

const SsoCallback = ({
  history,
  dispatchClearAuthState,
  fetchAuthenticatedUser,
  fetchClubs,
  createUserClub,
  setAuthTokens,
}) => {
  const { search } = useLocation()

  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {

    const handleSsoCallback = async () => {
      try {
        const query = new URLSearchParams(search)
        const tokenType = query.get('token_type')
        const accessToken = query.get('access_token')
        const refreshToken = query.get('refresh_token')

        if (tokenType !== 'Bearer' || !accessToken || !refreshToken) {
          setError('Invalid authentication request.')
          setLoading(false)

          return
        }

        setError('')
        setLoading(true)

        setAuthTokens({
          access_token: accessToken,
          refresh_token: refreshToken,
        })

        const res = await fetchAuthenticatedUser()
        const userData = res.response.data
        identify(userData.uuid)
        setLocale(userData.language)

        const clubsRes = await fetchClubs()
        const userClubs = clubsRes.response.data

        if (userClubs.length > 0) {
          history.push('/')
        } else {
          await createUserClub()
          history.push(`${getSignupURL()}/step2`)
        }
      } catch (err) {
        err.sentryEventId = Sentry.captureException(err)
        console.error('SSO callback error:', err)
        setError('Authentication failed. Please try again.')
      } finally {
        setLoading(false)
      }
    }

    handleSsoCallback()
  }, [dispatchClearAuthState, fetchAuthenticatedUser, history, search])

  return (
    <Container maxWidth="sm">
      <Box sx={{ m: '2rem' }}>
        {error && <ErrorMessage error={error} />}
        {loading && <LinearProgress />}
      </Box>
    </Container>
  )
}

SsoCallback.defaultProps = {
  dispatchClearAuthState: null,
}

SsoCallback.propTypes = {
  dispatchClearAuthState: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  fetchAuthenticatedUser: PropTypes.func.isRequired,
  fetchClubs: PropTypes.func.isRequired,
  createUserClub: PropTypes.func.isRequired,
  setAuthTokens: PropTypes.func.isRequired,
}

export default compose(
  withRouter,
  withLocalize,
  connect(
    ({ auth }) => ({
      authState: auth,
    }),
    {
      dispatchClearAuthState: authModule.clearAuthState,
      fetchAuthenticatedUser: authModule.fetchUser,
      fetchClubs: clubsModule.fetchClubs,
      createUserClub: clubsModule.createUserClub,
      setAuthTokens: authModule.setAuthTokens,
    }
  )
)(SsoCallback)
